module.exports = __webpack_public_path__ + "static/media/mydatafactoryhome.e54fc9b3.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/views/Help/assets/mydatafactoryhome.png
// module id = 1867
// module chunks = 193